import Vue from "vue";
import VueI18n from "vue-i18n";
import ru from "./ru";
import kz from "./kz";
import en from "./en";

Vue.use(VueI18n);

const messages = {
  ru,
  kz,
  en
};

const i18n = new VueI18n({
  locale: "ru",
  fallbackLocale: "kz",
  messages
});

export default i18n;
